<template>
  <div class="label-tip flex jcc aic" :class="[labelType]" :style="borderRadiusType"><span>{{text || autoText}}</span>
  </div>
</template>

<script>
  export default {
    name: "LabelTip",
    data() {
      return {}
    },
    computed: {
      autoText() {
        return {
          vip: 'VIP',
          pay: '付费',
          free: '免费',
          zt: '专题',
        }[this.labelType];
      },
      borderRadiusType() {
        let {radiusType: type, radiusSize: size} = this;
        type = Math.max(0, +type || 0);
        type = Math.min(15, +type || 0);
        type = ('0000' + (+type).toString(2)).slice(-4).split('').map(s => s * size).reverse();
        return 'border-radius: ' + type.join('px ') + 'px';
      },
    },
    props: {
      labelType: String,
      text: String,
      /**
       * 圆角类型 0 ~ 15
       * 左上：1， 右上：2， 右下：4，左下：8
       * 当圆角是 左上-右下时 type 为 1 + 4 = 5
       * 当圆角是 左上-左下时 type 为 1 + 8 = 9
       * ...
       * */
      radiusType: {
        type: String | Number,
        default: 15,
      },
      radiusSize: {
        type: Number | String,
        default: 4,
      },
    },
  }
</script>

<style scoped lang="less">
  .label-tip {
    padding: 0 6px 1px;
    color: #fff;
    font-size: 12px;
    line-height: 18px;
  }

  .vip {
    // font-size: 18px;
    // display: none;
    background: linear-gradient(90deg, #FDC301, #FFA500);
  }

  .pay {
    background: linear-gradient(90deg, #EE3F89, #B22DED);
  }

  .zt {
    background: rgba(0, 0, 0, .5);
  }

  .free {
    background: linear-gradient(90deg, #00E7C4, #00BBF2);
  }
</style>